export default defineNuxtRouteMiddleware((to) => {
  const { isPartner } = useCurrentUser()
  if (!isPartner.value) return navigateTo('/')
})
